module.exports = __webpack_public_path__ + "img/mel_skyline_2.e5cbba03.jpg";